import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SonarqubeConfigListing from './SonarqubeConfigListing'
import SonarqubeCredentialsForm from './SonarqubeCredentialsForm'

export default function SonarqubePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SonarqubeCredentialsForm}
            PullConfigListingView={SonarqubeConfigListing}
            RunOnDemandButtonText={'Sync tool components'}
        />
    )
}